import { gql } from '@apollo/client'
import { pathOr } from 'ramda'
import React from 'react'

import { generalClient } from '../../../utils/apollo/api'
import { usePromiseQuery } from '../../../utils/apollo/_helpers/promiseQuery'

import Select from '../../../packages/kiti/components/form/Select'

const QUERY = gql`
  query Masks($search: String, $page: Int, $filter: MaskFilter) {
    masks(search: $search, page: $page, filter: $filter, sort: { field: NAME, type: ASC }) {
      id
      name
    }
  }
`

export const useMaskLoader = filter => {
  const query = usePromiseQuery(QUERY, { client: generalClient })
  return (search, page = 1) => {
    return query({ search, page, filter })?.then(pathOr([], ['data', 'masks']))
  }
}

const MaskSelect = ({ onChange, value, ...props }) => {
  const getOptions = useMaskLoader({})

  return (
    <Select
      value={value} //
      onChange={onChange}
      options={getOptions}
      {...props}
    />
  )
}

export default MaskSelect
